import {
  Box, Form, ListItem, Text,
} from '@domain-group/suit-theme'

import type { ServiceGroup } from '../../hooks/useTemplatePageDetails'

interface ServiceProductsProps {
  groupedProductsByService: ServiceGroup[],
}

const ServiceProducts = (props: ServiceProductsProps) => {
  const { groupedProductsByService } = props

  return (
    <Form.Field label="Products" marginTop="large">
      {groupedProductsByService.map((group) => {
        const { groupKey, products } = group

        return (
          <ListItem
            boxProps={{ borderBottom: '1px dashed', paddingTop: 'medium' }}
            disableHover
            key={groupKey}
          >
            <Text fontSize="small" width="50%">
              {groupKey}
            </Text>

            <Box flexDirection="column" textAlign="right" width="50%">
              {products.map(product => (
                <Text
                  color="mysteryGrey"
                  fontSize="small"
                  key={product.id}
                  marginBottom="medium"
                  variant="ellipsis"
                >
                  {product.title}
                </Text>
              ))}
            </Box>
          </ListItem>
        )
      })}
    </Form.Field>
  )
}

export default ServiceProducts
